import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';

let blankItemStyle = getItemStyles('no-info');

const blockFutureUnpostedDays = (groups, items, scheduleFormat) => {
  const currentDate = moment();
  for (let group of groups){
    for (let i = 1; i < scheduleFormat; i++) {
      const date = moment(currentDate).add(i, 'days');
      // console.log(`${group.id}: ${date.format('M/D')}`); // debug
      // check if group (resource) has any items on this day
      const haveItem = items.some(item => {
        return (
          item.group === group.id
          &&
          item.start_time.format('M/D') === date.format('M/D')
        );
      });
      if (!haveItem) {
        const blankItem = {
          id: `${group.id}-no-info-${date.format('M/D')}`,
          itemType: 'no-info',
          group: group.id,
          title: "No info",
          start_time: moment(date).startOf('day'),
          end_time: moment(date).endOf('day'),
          backgroundColor: blankItemStyle.backgroundColor,
          color: blankItemStyle.color,
          borderStyle: blankItemStyle.borderStyle,
          borderColor: blankItemStyle.borderColor
          };
          items.push(blankItem);
      }
    }
  }
  return items;
}

export default blockFutureUnpostedDays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/live-schedule-view-security-filter/blockFutureUnpostedDays.js